import {Injectable} from '@angular/core';
import {ApiService} from '../api/api.service';
import {ServiceStatus} from '../../models/service-status';

@Injectable({providedIn: 'root'})
export class ServiceStatusService {
  private statusPromise: Promise<ServiceStatus | null> | null = null;

  constructor(private api: ApiService) {}

  public getStatus(): Promise<ServiceStatus | null> {
    if (!this.statusPromise) {
      this.statusPromise = this.api.getServiceStatus().catch(() => null);
    }
    return this.statusPromise;
  }

  public isInMaintenance(): Promise<boolean> {
    return this.getStatus().then(status => status?.quit === true);
  }
}
